export var onLogout = function () {
    var redirectTo = sessionStorage.getItem('anx_oos_rto');
    sessionStorage.removeItem('anx_oss_a');
    sessionStorage.removeItem('anx_oos_rto');
    sessionStorage.removeItem('anx_oos_mfv');
    window.location.replace(redirectTo ? redirectTo : '/');
};
